import { useState } from "react";
import { Logo, LogoText, HamburgerButton, MenuLinks, MobileMenu } from "../ui-elements";
import LightDarkToggle from "../ui-elements/LightDarkToggle";
import ButtonPrimary from "../ui-elements/ButtonPrimary";
import ButtonSecondary from "../ui-elements/ButtonSecondary";
import navigationContent from "../../../content/navigation/navigation.json";

export const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigationLinks = navigationContent.links ?? [];
  const highlightedButtons = navigationContent.buttons ?? [];

  return (
    <>
      <nav id="top" className="flex items-center h-16 px-3 m-0 md:px-4 dark:bg-dark-purple-ui bg-gray-50">
        <div className="flex items-center justify-between w-full md:mx-4 lg:mx-8 2xl:w-[80em] 2xl:mx-auto">
          <div className="sm:hidden">
            <div className="flex gap-4 items-center">
              <LightDarkToggle />
            </div>
          </div>
          <div className="flex items-center justify-center">
            <div className="hidden md:block">
              <Logo />
            </div>
            <div className="hidden md:block">
              <LogoText />
            </div>
            <div className="relative hidden ml-4 text-gray-600 top-[1px] md:block">
              <MenuLinks menuLinks={navigationLinks} />
            </div>
          </div>
          <div className="absolute block transform -translate-x-1/2 md:hidden left-1/2">
            <div className="flex items-center justify-center">
              <Logo />
              <LogoText />
            </div>
          </div>
          {/* <div className="flex items-center justify-center gap-4">
            <div className="hidden md:block">
              <KbarInput />
            </div>
          </div> */}
          <div className="hidden md:block"></div>
          <div className="hidden md:block">
            <div className="flex gap-4 items-center">
              <LightDarkToggle />
              {highlightedButtons.map((button) =>
                button.style === "primary" ? (
                  <ButtonPrimary key={button.url} url={button.url} label={button.label} />
                ) : (
                  <ButtonSecondary key={button.url} url={button.url} label={button.label} />
                )
              )}
            </div>
          </div>
          <div className="md:hidden">
            <div className="flex gap-4 items-center">
              <span className="hidden sm:inline-block">
                <LightDarkToggle />
              </span>
              <HamburgerButton isOpen={isMobileMenuOpen} onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} />
            </div>
          </div>
        </div>
        <div className="md:hidden">
          {isMobileMenuOpen && (
            <MobileMenu
              menuLinks={navigationLinks}
              buttons={highlightedButtons}
              onClose={() => setIsMobileMenuOpen(false)}
            />
          )}
        </div>
      </nav>
    </>
  );
};
